'use client'
import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { CreateHypothesisDto } from '../../lib'
import { methods } from '@/shared/api/constants'
import { CreateHypothesisParams } from '@/shared/api/end-points/hypothesis'

const create = async (dto: CreateHypothesisDto, params: CreateHypothesisParams) => {
  const res = await api.json<Partial<CreateHypothesisDto>>(API_END_POINTS.hypothesis.create(params), {
    method: methods.post,
    body: JSON.stringify(dto),
  })

  if (res.ok) return res.result
  if (!res.ok) throw new Error(res?.message || res?.error)
}

export default create
